import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: 'login', component: LoginComponent },
  { path: '', loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)},
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard-user/dashboard-user.module').then(m => m.DashboardUserModule)},
  { path: 'app', loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule)},
  { path: 'provider', loadChildren: () => import('./modules/provider/provider.module').then(m => m.ProviderModule)},
  { path: 'store', loadChildren: () => import('./modules/store/store.module').then(m => m.StoreModule)},
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)},
  { path: 'esign', loadChildren: () => import('./modules/esign/esign.module').then(m => m.EsignModule)},
  { path: 'doc-cap', loadChildren: () => import('./modules/doc-cap/doc-cap.module').then(m => m.DocCapModule)},
  { path: 'doc-certificate-of-completion', loadChildren: () => import('./modules/doc-certificate-of-completion/doc-certificate-of-completion.module').then(m => m.DocCertificateOfCompletionModule)},
  { path: 'booking', loadChildren: () => import('./modules/yeehro-calendly-booking-public/yeehro-calendly-booking-public.module').then(m => m.YeehroCalendlyBookingPublicModule)},
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
